<template lang="html">
  <span class="mpv-tooltip-with-icon">
    <i :class="`mpv-tooltip-with-icon-fig ${icon ? icon : 'fa fa-question-circle'}`"></i>
    <span :class="`tooltip-with-icon-text ${standalone ? 'standalone' : ''}`">{{ text }}</span>
  </span>
</template>

<script>
export default {
  props: {
    text: String,
    standalone: Boolean,
    icon: String
  }
}
</script>

<style lang="scss">
  @import '../../scss/colors';

  .mpv-tooltip-with-icon {
    position: relative;

    &-fig {
        color: $secondary !important;
        font-size: 1rem !important;
        padding-left: 0.5rem;

        & ~ .tooltip-with-icon-text {
          display: none;
          opacity: 0;
          position: absolute;
          text-align: center;
          bottom: 140%;
          right: -5%;
          width: max-content;
          max-width: 320px;
          padding: 0.25rem 0.5rem;
          background-color: $dark;
          color: $white;
          font-size: 90% !important;
          line-height: 1rem;
          border-radius: 3px;
          box-shadow: 1px 2px $gray-200;
          transition: ease 0.3s;
          z-index: 1;

          &.standalone {
            left: 0 !important;

            &:before {
              left: 14px !important;
              right: unset;
            }
          }

          &:before {
            position: absolute;
            bottom: -8px;
            right: 5%;
            border-left: -3px solid transparent;
            border-right: 8px solid transparent;
            border-top: 9px solid $dark;
            content: "";
          }
        }

        &:hover ~ .tooltip-with-icon-text {
          opacity: 1;
          display: block;
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/TooltipIcon.vue